<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户ID：">
          <el-input v-model="searchValue.user_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchWhiteUserList"
            >查询</el-button
          >
          <el-button type="success" plain @click="addWhiteUserDialog"
            >新增白名单</el-button
          >
          <el-button :loading="inputLoading" type="warning" plain @click="$refs.importCsv.click()"
            >批量导入</el-button
          >
          <el-button type="success" plain @click="$refs.template.click()"
            >下载导入模板</el-button
          >
          <a ref="template" :href="template" download="用户白名单批量导入模板.xlsx" style="display: none;"></a>
          <input style="display:none" @change="csvChange" type="file" id="importCsv" ref="importCsv" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
        </el-form-item>
      </el-form>
    </div>
    <!-- phone白名单列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="user_id" label="用户ID" width="150"> </el-table-column>
      <el-table-column prop="user.username" label="用户名"> </el-table-column>
      <el-table-column prop="created_at" label="创建日期"> </el-table-column>
      <el-table-column prop="admin.name" label="操作人员"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" plain @click="del_whiteUser(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加白名单弹出框 -->
    <el-dialog
      title="添加白名单"
      :visible.sync="addDialogFormVisible"
      width="28%"
      class="addWhite"
    >
      <el-form>
        <el-form-item label="用户ID:">
          <el-input v-model="user_id"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWhiteUserSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import XLSX from 'xlsx'
import template from './template.xlsx'

export default {
  name: "whiteUser",
  components: {},
  data() {
    return {
      loadingData: false,
      addDialogFormVisible: false,
      searchValue: {
        user_id: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      user_id: "",
      remark: "",
      inputLoading: false,
      template,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getWhiteUserList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    csvChange () {
      const file = this.$refs.importCsv.files && this.$refs.importCsv.files[0]
      if (file) { 
        const reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = async (e) => {
          let keyConfig = {
            '用户ID': 'user_id',
            '备注': 'remark',
          }
          let dataList = {}
          let keyList = {}
          const csv = XLSX.read(e.target.result, {type: 'binary'})
          if (csv && csv.SheetNames && csv.SheetNames.length && csv.Sheets) {
            const sheet = csv.Sheets[csv.SheetNames[0]]
            for (let key in sheet) {
              const code = key.replace(/[^A-Z]/g, '')
              const index = key.replace(/[^0-9]/g, '')
              const value = sheet[key] && sheet[key].v
              if (index === '1') {
                keyList[code] = keyConfig[value]
              } else if (index) {
                if (!dataList[index]) dataList[index] = {}
                if (keyList[code]) {
                  let val = sheet[key] && sheet[key].v
                  dataList[index][keyList[code]] = val
                }
              }
            }
            let list = []
            this.inputLoading = true
            for (let data in dataList) {
              list.push(dataList[data])
            }
            await fetch({
              url: "/admin/white_users/add",
              method: "POST",
              data: {
                batch: list
              },
            }).then((res) => {
              if (res.data.status) {
                this.$message({
                  type: "success",
                  message: "批量新增白名单成功！",
                });
                this.getWhiteUserList();
              } else {
                this.$message.error(res.data.message);
              }
            }).finally(() => this.inputLoading = false)
          }
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWhiteUserList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWhiteUserList(false);
    },
    // 实现游戏数据搜索
    searchWhiteUserList() {
      this.currentPage = 1;
      this.getWhiteUserList(true);
    },
    // 删除
    del_whiteUser(id) {
      this.$confirm("是否确定删除该数据?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del_whiteUserSubmit(id);
        })
        .catch(() => {});
    },
    del_whiteUserSubmit(id) {
      fetch({
        url: "/admin/white_users/delete",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getWhiteUserList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增白名单
    addWhiteUserDialog() {
      this.user_id = "";
      this.remark = ""
      this.addDialogFormVisible = true;
    },
    // 新增白名单提交操作
    addWhiteUserSubmit() {
      fetch({
        url: "/admin/white_users/add",
        method: "POST",
        data: {
          user_id: this.user_id,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "新增白名单成功！",
          });
          this.addDialogFormVisible = false;
          this.getWhiteUserList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示phone拉黑列表数据
    getWhiteUserList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/white_users/list",
        method: "GET",
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          ...searchValue
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.addWhite {
  .el-form-item {
    display: flex;
    // justify-content: center;
    .el-input {
      width: 320px;
    }
  }
}
</style>
